import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ResourceProvider } from '../../providers/resource/resource';
import { Country } from '../../model/myria/app/country';

@Component({
  selector: 'rmt-country-send',
  templateUrl: 'rmt-country-send.html'
})
export class RmtCountrySendComponent {
  @ViewChild('country') country;
  @Input() disable: boolean = false;
  @Output() ionChange = new EventEmitter<string>();
  countriesPromise;
  countriesResolve;
  favoritePromise;
  favoriteResolve;
  countries: Array<Country>;
  lastCountry;

  constructor(private resourceProvider: ResourceProvider) {
    this.countriesPromise = new Promise((resolve) => {
      this.countriesResolve = resolve;
    });
    this.favoritePromise = new Promise((resolve) => {
      this.favoriteResolve = resolve;
    });
  }

  async ngOnInit() {
    const favorites = await this.resourceProvider.getTopCountries();
    const countries = await this.resourceProvider.getSendCountries();

    this.countries = [];
    for (let i = 0; i < countries.length; i++) {
      this.countries.push(countries[i].value);
    }
    this.countriesResolve(this.countries);
    this.favoriteResolve(favorites);
  }

  showPicker() {
    this.country.showPicker();
  }

  setValue(value) {
    this.country.setValue(value);
  }

  selectCountry(ev) {
    if (ev !== this.lastCountry) {
      this.lastCountry = ev;
      this.ionChange.emit(ev);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-country-send/rmt-country-send.ts